import { createFileRoute } from '@tanstack/react-router';
import { SiloDriftReport } from '../../../features/reports/screens/SiloDriftReport';

/** Owned by G25. Report #5 — silo drift history. */
export const Route = createFileRoute('/_authenticated/reports/silo-drift')({
  component: SiloDriftReport,
});
